//--------------------------------------------------
// imported classes
//--------------------------------------------------
const BaseMediator = require('@/tbs/controller/BaseMediator')
const ClassFunc = require('@/tbs/util/ClassFunc')
const Organization = require('@/tbs/model/vo/Organization')
const DataConvertor = require('@/tbs/core/DataConvertor')
const ObjectFunc = require('@/tbs/util/ObjectFunc')
// const ModelLocator = require('@/tbs/model/ModelLocator')

/**
 * The MatchMediator class maintains the business logic
 * for the organization.
 */
const tbs_controller_OrganizationManagerMediator = function() {
    //--------------------------------------------------
    // super method for the base class
    //--------------------------------------------------
    ClassFunc.super(this, BaseMediator, arguments)
    // console.log('tbs_controller_OrganizationManagerMediator constructor')
}

//--------------------------------------------------
// prototype
//--------------------------------------------------
tbs_controller_OrganizationManagerMediator.prototype = {
    //--------------------------------------------------
    // api method
    //--------------------------------------------------
    /**
     * @api
     * Handle the creation complete condition triggered by 
     * the scene instance.
     */
    handleCreationComplete: function() {
         console.log('handleCreationComplete', this._bridge.getRouteParam('id'))
        const organizationId = this._bridge.getRouteParam('id')
        if (organizationId == null) {
             console.log('no organization id')
             this.loadOrganizationList()
        }
        else {
            this.creationComplete()
        }
    },
    handleDataLoaded: function() {
        // scroll back to top
        setTimeout(function() {
            window.scrollTo(0, 0);
            document.body.scrollTop = 0;
        }, 200)
    },
    handleRouteBack: function() {
        if (this._bridge.getRouteName() == 'OrgManageOrganization') {
            this.exitPage()
        }
        else {
            this._bridge.back()
        }
    },
    loadOrganizationList: function() {
        const self = this
        const convertor = new Organization()
        const wrapper = DataConvertor.wrapper(convertor)
        const source = convertor.view.query
        const service = 'query' + ObjectFunc.capitalizeFirstLetter(wrapper)
        self._bridge.addResourceListener(service, function(e) {
            self._bridge.removeResourceListener(service, e.handler)
            console.log('query.data', service, e.data)
            // self.handleQueryService(e)
            if (e.data.result) {
                if (e.data.payload && e.data.payload.data.list.length > 0) {
                    const selectedOrganization = e.data.payload.data.list[0]
                    self._bridge.goToScene('OrgManageOrganization', {id: selectedOrganization.id})
                }
                else {
                    console.log('no organization owned')
                    // redirect to the organization list page
                    self._bridge.goToScene('OrgListOrganization', {}, {from: 'OrgManageOrganization', action: 'exit'})
                }
            }
        })
        self._bridge.callResourceInstance(service, {
            baseUrl: source.baseUrl,
            apiPrefix: source.apiPrefix,
            apiSuffix: source.apiSuffix,
            serviceName: source.service,
            method: 'GET'
        })
    }
}

//--------------------------------------------------
// extends the BaseMediator
//--------------------------------------------------
ClassFunc.extend(tbs_controller_OrganizationManagerMediator, BaseMediator);

module.exports = tbs_controller_OrganizationManagerMediator